// @flow

export { default as favouriteGamesUpdate } from './favouriteGamesUpdate'
export { default as activitiesUpdate } from './activitiesUpdate'
export { default as traitsUpdate } from './traitsUpdate'
export { default as descriptionsUpdate } from './descriptionsUpdate'
export { default as imageUpload } from './imageUpload'
